import type { WorkSchedule, WorkScheduleDay } from '@trinnvis/dabih-api-client';
import { DayOfWeek, LocalDate } from '../../../utilities/local-date';
import { forDayIndex } from './for-day-index';

/**
 * Takes a number of weeks in schedule, the current schedule and a day date
 * Returns the week schedule for the day
 */
export function getScheduleForDay(
  weeksInSchedule: number,
  currentSchedule: WorkSchedule,
  day: LocalDate,
): WorkScheduleDay {
  const dayIndex = day.dayOfWeek().valueOf();
  if (weeksInSchedule === 1) {
    return forDayIndex(currentSchedule.workWeeks[0], dayIndex);
  } else {
    const startDate = LocalDate.fromString(currentSchedule.start);
    const startDateWeekStart = startDate.withPreviousOrSame(DayOfWeek.MONDAY);
    const thisDayWeekStart = day.withPreviousOrSame(DayOfWeek.MONDAY);
    const thisWeekCount = startDateWeekStart.until(thisDayWeekStart) / 7 + 1;
    let theRightWeek;
    if (thisWeekCount <= weeksInSchedule) {
      theRightWeek = thisWeekCount;
    } else {
      theRightWeek = thisWeekCount % weeksInSchedule;
    }
    if (theRightWeek === 0) {
      theRightWeek = weeksInSchedule;
    }
    const weekIndex = theRightWeek - 1;
    return forDayIndex(currentSchedule.workWeeks[weekIndex], dayIndex);
  }
}
